/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ContainerFindingsFiltersSortCriteria {
    getFixupPrototypeFunction() { return ContainerFindingsFiltersSortCriteria.fixupPrototype; }

    static newInstance(model: Partial<ContainerFindingsFiltersSortCriteria>): ContainerFindingsFiltersSortCriteria {
        let obj = Object.assign(new ContainerFindingsFiltersSortCriteria(), model);
        ContainerFindingsFiltersSortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ContainerFindingsFiltersSortCriteria>): ContainerFindingsFiltersSortCriteria {
        if (!model) return null;
        return ContainerFindingsFiltersSortCriteria.newInstance(<ContainerFindingsFiltersSortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ContainerFindingsFiltersSortCriteria) {
        if (!obj) return;

        models.ContainerFindingsFiltersSortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ContainerFindingsFiltersSortCriteria): boolean {
        Object.setPrototypeOf(obj, ContainerFindingsFiltersSortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.ContainerFindingsFiltersSortColumn;

    ascending: boolean;

}
